<template>
  <a-card :bordered="false" title="发票详情" :headStyle="{ fontSize: '18px' }">
    <a-card :bordered="false" :bodyStyle="{ padding: '0px' }" :headStyle="{ borderBottom: '0px', paddingLeft: '0px' }">
      <a-row slot="title">
        <a-col :span="8">
          <span class="card-title">发票申请信息</span>
        </a-col>
      </a-row>
      <a-table rowKey="id" :columns="columns" :data-source="applyData">
        <span slot="headerType" slot-scope="text">{{ text == 1 ? '企业' : '' }}</span>
        <span slot="invoiceType" slot-scope="text">{{ text | invoiceTypeName }}</span>
        <span slot="action" slot-scope="text, record">
          <a v-if="record.status == 1" @click="showModel(record.id)">审核申请</a>
          <a v-else @click="showModel(record.id)">查看</a>
        </span>
      </a-table>
    </a-card>
    <a-card :bordered="false" :bodyStyle="{ padding: '0px' }" :headStyle="{ borderBottom: '0px', paddingLeft: '0px' }">
      <a-row slot="title">
        <a-col :span="8">
          <span class="card-title">订单明细信息</span>
        </a-col>
      </a-row>
      <custom-page-table ref="table" rowKey="orderNo" :columns="columnsDetail" :requestPromise="loadPromise">
      </custom-page-table>
    </a-card>
    <a-modal title="审核发票申请" :visible="visible" :width="670" @cancel="visible = false" :footer="null">
      <div>
        <div class="form" style="font-size: 18px;">
          <span>发票开具总金额：</span>
          <span style="color: #f25001;">{{ applylist.invoiceAmount }}</span
          >元
        </div>
        <div class="form">
          <span>发票抬头：</span>
          {{ applylist.invoiceHeader }}
        </div>
        <div class="form">
          <span>抬头类型：</span>
          {{ applylist.headerTypeStr }}
        </div>
        <div class="form">
          <span>发票类型：</span>
          {{ applylist.invoiceTypeStr }}
        </div>
        <div class="form">
          <span>纳税人识别号：</span>
          {{ applylist.taxpayerIdentificationNumber }}
        </div>
        <div class="form">
          <span>收票人姓名：</span>
          {{ applylist.receiveInvoiceName }}
        </div>
        <div class="form">
          <span>收票人电话：</span>
          {{ applylist.receiveInvoiceMobile }}
        </div>
        <div class="form" v-if="applylist.invoiceType !== 1">
          <span>收票地址：</span>
          {{ applylist.receiveInvoiceLinkContent }}
        </div>
        <div class="form" v-else>
          <span>收票人邮箱：</span>
          {{ applylist.receiveInvoiceLinkContent }}
        </div>
        <div v-if="applylist.status == 2">
          <div class="form" v-if="applylist.invoiceType == 2 || applylist.invoiceType == 3">
            <span>快递单号：</span>
            {{ applylist.expressDelivery }}
          </div>
        </div>
        <div class="form">
          <span>备注：</span>
          {{ applylist.remark }}
        </div>
        <div v-if="applylist.status == 1">
          <div v-if="applylist.invoiceType == 2 || applylist.invoiceType == 3">
            <a-row>
              <a-col style="margin-left:15px" :span="3">
                <span>快递单号：</span>
              </a-col>
              <a-col :span="20">
                <a-textarea
                  v-model="expressDelivery"
                  placeholder="请输入快递公司及单号，如顺丰，28827277272"
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-col>
            </a-row>
          </div>
        </div>
        <div style="margin: 35px 0 15px 80px;">
          <a-button v-if="applylist.status == 1 && applylist.invoiceType !== 1" type="primary" @click="submit"
          >确定已开票
          </a-button
          >
          <a-button v-if="applylist.invoiceType == 1 && applylist.status == 1" type="primary" @click="submit"
          >确定已开票
          </a-button
          >
          <a-button v-if="applylist.status == 2" type="primary" @click="visible = false">确认</a-button>
          <a-button style="margin-left:5%" @click="visible = false">取消</a-button>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      id: this.$route.query.id,
      loadPromise: params => this.getRecordData(params),
      columns: [
        {
          title: '申请时间',
          dataIndex: 'createTime'
        },
        {
          title: '发票抬头',
          dataIndex: 'invoiceHeader'
        },
        {
          title: '金额',
          dataIndex: 'invoiceAmount'
        },
        {
          title: '抬头类型',
          dataIndex: 'headerType',
          scopedSlots: { customRender: 'headerType' }
        },
        {
          title: '发票类型',
          dataIndex: 'invoiceType',
          scopedSlots: { customRender: 'invoiceType' }
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsDetail: [
        {
          title: '订单编号',
          dataIndex: 'orderNo'
        },
        {
          title: '商品信息',
          dataIndex: 'productMsg'
        },
        {
          title: '金额',
          dataIndex: 'orderAmount'
        },
        {
          title: '支持发票类型',
          dataIndex: 'invoiceType'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        }
      ],
      value: '',
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {},
      ruleForm: [],
      applyData: [],
      visible: false,
      applylist: {},
      expressDelivery: ''
    }
  },
  mounted() {
    this.getApplyData()
  },
  methods: {
    showModel(id) {
      this.visible = true
    },
    submit() {
      this.getHttpServices()
        .getCloudUserService()
        .post('invoice/v2/auditInvoice', {
          invoiceId: this.id,
          expressDelivery: this.expressDelivery
        })
        .then(res => {
          this.$message.success('提交成功')
          this.visible = false
          this.applyData = {}
          this.getApplyData()
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    getApplyData() {
      return this.getHttpServices()
        .getCloudUserService()
        .post('invoice/v2/getAuditInvoiceDetail', { invoiceId: this.id })
        .then(res => {
          this.applylist = res
          this.applyData.push(res)
          this.getLogUtils().logWithTag('==this.applyData==', this.applyData)
        })
        .catch(err => {
        })
    },
    getRecordData(params) {
      params.invoiceId = this.id
      return this.getHttpServices()
        .getCloudUserService()
        .post('invoice/v2/getAuditInvoiceOrderList', params)
    }
  }
}
</script>
<style scoped>
* {
  margin: 0;
}

.form {
  margin: 15px 0 15px 15px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>
